export default "__VITE_ASSET__DQ0MXhZ8__"